import { createContext, Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react';

type ContextType = {
  baseUrl: string;
  jwt?: string;
  setJwt?: Dispatch<SetStateAction<string | undefined>>;
  setBaseUrl?: Dispatch<SetStateAction<string>>;
};

export const ServiceConfigContext = createContext<ContextType>({ baseUrl: '' });

export const ServiceProvider = ({
  children,
  baseUrl: inputBaseUrl,
  jwt: inputJwt,
}: {
  children: ReactNode;
  baseUrl: string;
  jwt?: string;
}) => {
  const [jwt, setJwt] = useState(inputJwt);
  const [baseUrl, setBaseUrl] = useState(inputBaseUrl);

  useEffect(() => setJwt(inputJwt), [inputJwt]);
  useEffect(() => setBaseUrl(baseUrl), [baseUrl]);

  return <ServiceConfigContext.Provider value={{ baseUrl, jwt }}>{children}</ServiceConfigContext.Provider>;
};
